(function () {
  const ACCORDION_SELECTOR = '.customer-care-faq-accordion';
  const ITEM_SELECTOR = '.cc-accordion-item';
  const TITLE_SELECTOR = '.cc-accordion-item__title';
  const PANEL_SELECTOR = '.cc-accordion-item__panel';
  const DURATION_MS = 300;

  class CustomerCareFaqAccordion {
    constructor(container) {
      this.container = container;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      container.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
        const panel = item.querySelector(PANEL_SELECTOR);
        if (!panel) {
          return;
        }

        if (item.hasAttribute('open')) {
          item.classList.add('is-open');
          panel.style.maxHeight = 'none';
          return;
        }

        panel.style.maxHeight = '0px';
      });

      if (this.reducedMotion) {
        return;
      }

      this.onClick = this.handleClick.bind(this);
      this.onTransitionEnd = this.handleTransitionEnd.bind(this);
      container.addEventListener('click', this.onClick);
      container.addEventListener('transitionend', this.onTransitionEnd);
    }

    setPanelHeight(panel, height) {
      panel.style.maxHeight = typeof height === 'number' ? `${height}px` : height;
    }

    open(item) {
      const panel = item.querySelector(PANEL_SELECTOR);
      if (!panel) {
        return;
      }

      item.classList.remove('is-closing');
      item.open = true;
      this.setPanelHeight(panel, 0);

      requestAnimationFrame(() => {
        item.classList.add('is-open');
        this.setPanelHeight(panel, panel.scrollHeight);

        window.setTimeout(() => {
          if (item.classList.contains('is-open') && !item.classList.contains('is-closing')) {
            this.setPanelHeight(panel, 'none');
          }
        }, DURATION_MS + 50);
      });
    }

    close(item) {
      const panel = item.querySelector(PANEL_SELECTOR);
      if (!panel || item.classList.contains('is-closing')) {
        return;
      }

      this.setPanelHeight(panel, panel.scrollHeight);
      item.classList.remove('is-open');
      item.classList.add('is-closing');

      requestAnimationFrame(() => {
        this.setPanelHeight(panel, 0);
      });
    }

    handleClick(event) {
      const toggle = event.target.closest(TITLE_SELECTOR);
      if (!toggle || !this.container.contains(toggle)) {
        return;
      }

      event.preventDefault();

      const item = toggle.closest(ITEM_SELECTOR);
      if (!item) {
        return;
      }

      if (item.classList.contains('is-open') && !item.classList.contains('is-closing')) {
        this.close(item);
        return;
      }

      this.open(item);
    }

    handleTransitionEnd(event) {
      if (event.propertyName !== 'max-height') {
        return;
      }

      const panel = event.target;
      if (!panel.matches(PANEL_SELECTOR)) {
        return;
      }

      const item = panel.closest(ITEM_SELECTOR);
      if (!item) {
        return;
      }

      if (item.classList.contains('is-closing')) {
        item.classList.remove('is-closing');
        item.open = false;
        panel.style.maxHeight = '0px';
        return;
      }

      if (item.classList.contains('is-open')) {
        panel.style.maxHeight = 'none';
      }
    }
  }

  function initCustomerCareFaqAccordions(scope) {
    const root = scope || document;
    root.querySelectorAll(ACCORDION_SELECTOR).forEach((container) => {
      if (container.dataset.faqAccordionInit === 'true') {
        return;
      }

      container.dataset.faqAccordionInit = 'true';
      new CustomerCareFaqAccordion(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomerCareFaqAccordions());
  } else {
    initCustomerCareFaqAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomerCareFaqAccordions(event.target);
  });
})();
